import { render, staticRenderFns } from "./SurveyQuestionComments.vue?vue&type=template&id=8575c55c&scoped=true&"
import script from "./SurveyQuestionComments.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionComments.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionComments.vue?vue&type=style&index=0&id=8575c55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8575c55c",
  null
  
)

export default component.exports